import React, { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useInsightsService } from '@lib/insightsService';
import { ActionText, Alert } from '@components';

import { StepOne, StepTwo } from './Steps';

const SECURITY_ALERTS = {
  inactiveAccount: {
    title: '¡Qué gusto verte de nuevo!',
    message: 'Como tu cuenta no se ha usado en más de 12 meses, activamos una verificación rápida '
      + 'para proteger tu información.',
    redirectUrl: email => `/inactive-account-unlock?email=${encodeURIComponent(email)}`
  },
  unusualAccess: {
    title: 'Confirma tu identidad',
    message: 'Estás intentando iniciar sesión desde una ubicación distinta a la habitual. '
      + 'Por seguridad, tu acceso está pausado temporalmente hasta que lo confirmes '
      + 'con un código por correo.',
    redirectUrl: email => `/unusual-access-unblock?email=${encodeURIComponent(email)}`
  }
};

const Login = () => {
  const { authenticationEvent, reportInsight } = useInsightsService();
  const [step, setStep] = useState('email');
  const [email, setEmail] = useState('');
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [twoFactorCodeUrl, setTwoFactorCodeUrl] = useState('');
  const [antiphishingData, setAntiphishingData] = useState({});
  const [alertData, setAlertData] = useState({ title: '', message: '' });

  const navigate = useNavigate();

  const handleStepOneSuccess = (userEmail, antiphishingResponse) => {
    setStep('password');
    setEmail(userEmail);
    setAntiphishingData(antiphishingResponse);
  };

  const handleCancelation = () => {
    setIsAlertVisible(false);
    setStep('email');
  };

  const handleSuccessfulLogin = () => {
    reportInsight(authenticationEvent.successful);
  };

  const handleSecurityAlert = alertType => {
    const { title, message, redirectUrl } = SECURITY_ALERTS[alertType];

    setAlertData({ title, message });
    setIsAlertVisible(true);
    setTwoFactorCodeUrl(redirectUrl(email));
  };

  return (
    <Fragment>
      {isAlertVisible && (
        <Alert
          alertType="WARNING"
          isIconVisible={false}
          title={alertData.title}
          message={alertData.message}
        >
          <ActionText
            id="twoFactorCode-send-email"
            color="info"
            onClick={() => navigate(twoFactorCodeUrl)}
          >
            Enviar correo
          </ActionText>
        </Alert>
      )}

      <br />

      {Boolean(step === 'email') && (
        <StepOne onSuccess={handleStepOneSuccess} />
      )}

      {Boolean(step === 'password') && (
        <StepTwo
          email={email}
          antiphishingData={antiphishingData}
          onCancel={handleCancelation}
          onSuccess={handleSuccessfulLogin}
          displayInactiveAccount={() => handleSecurityAlert('inactiveAccount')}
          displayUnusualAccess={() => handleSecurityAlert('unusualAccess')}
        />
      )}
    </Fragment>
  );
};

export default Login;
